export default __webpack_public_path__ + "static/media/mutualOfOmaha.d4db6d6f.png";